import { render, staticRenderFns } from "./KeyboardCallbackForm.vue?vue&type=template&id=287c00fe&scoped=true"
import script from "./KeyboardCallbackForm.vue?vue&type=script&lang=js"
export * from "./KeyboardCallbackForm.vue?vue&type=script&lang=js"
import style0 from "./KeyboardCallbackForm.vue?vue&type=style&index=0&id=287c00fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c00fe",
  null
  
)

export default component.exports